import React, { useEffect, useRef, useState } from 'react';

export const SkeletonContext = React.createContext();

export default function SkeletonContextProvider(props) {
    const [showSkeleton, setShowSkeleton] = useState(true);
    const handle = useRef(null);

    useEffect(() => {
        if (props.isLoading) {
            handle.current = setTimeout(() => setShowSkeleton(true), 500);
        } else {
            clearTimeout(handle.current);
            setShowSkeleton(false);
        }

        return () => clearTimeout(handle.current);
    }, [props.isLoading]);

    return (
        <SkeletonContext.Provider
            value={{ showSkeleton, dataLoading: props.isLoading }}
        >
            {props.children}
        </SkeletonContext.Provider>
    );
}
